module.exports = __webpack_public_path__ + "static/media/exitRight.3e747cbf.svg";